export default "__VITE_ASSET__CwRyv4sU__"